var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGridEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9 22.61c-.52.52-1.38.52-1.92 0l-1.58-1.59c-.52-.53-.52-1.38 0-1.92l1.91-1.89 3.49 3.49-1.9 1.91zM19.8 19.7l-3.49-3.49 2.8-2.82c.53-.52 1.39-.52 1.92 0l1.58 1.59c.52.53.52 1.4 0 1.92l-2.81 2.8zM6.75 7.8H3.498a1 1 0 0 1-.907-1.423C3.947 3.471 5.666 2.012 7.75 2v4.8a1 1 0 0 1-1 1zM16.25 6.8V3.438a1 1 0 0 1 1.385-.923c2.629 1.098 4.06 2.486 4.295 4.165.08.59-.4 1.12-1 1.12h-3.68a1 1 0 0 1-1-1zM7.616 21.173c-.314.545-.646.794-.996.748-2.89-.43-4.58-2.46-4.62-5.62h4.75a1 1 0 0 1 1 1v3.372a1 1 0 0 1-.134.5zM2 10.3v3.5a1 1 0 0 0 1 1h3.75a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM9.25 10.3v3.5a1 1 0 0 0 1 1h3.27a1 1 0 0 0 .47-.116c.506-.269.76-.563.76-.883v-3.5a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1zM9.25 3v3.8a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGridEraser);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-eraser.e01b6980343faee0b280ff680967df72.svg";
export { ForwardRef as ReactComponent };